<template>
  <Modal v-model="visible" title="新增付款" :footer-hide="true" :mask-closable="false" class="my-modal top" width="800px" @on-cancel="cancel">
    <Form ref="formValidate" :label-width="100" :model="searchParams">
      <FormItem label="凭证编号" prop="paymentCode">
        <Input v-model="searchParams.paymentCode" placeholder="请输入" clearable />
      </FormItem>
      <FormItem label="付款日期" prop="paymentDate" :rules="$units.formRule.objRequired('请选择开票日期')">
        <DatePicker transfer v-model="searchParams.paymentDate" format="yyyy-MM-dd" type="date" placeholder="请选择">
        </DatePicker>
      </FormItem>
      <FormItem label="付款金额" prop="paymentAmount" :rules="$units.formRule.required('请输入收款金额')">
        <Input v-model="searchParams.paymentAmount" placeholder="请输入" clearable />
      </FormItem>
      <FormItem label="付款账户" prop="paymentAccount">
        <Input v-model="searchParams.paymentAccount" placeholder="请输入" clearable />
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="cancel">取消</Button>
      <Button type="primary" @click="submit">确定</Button>
    </div>
  </Modal>
</template>

<script>
import uploadNew from "@/components/commons/uploadNew";
export default {
  components: {uploadNew},
  data(){
    return{
      visible:false,
      imgUrl: "",
      searchParams:{},
    }
  },
  methods:{
    cancel(){
      this.visible = false
      this.searchParams={}
    },
    submit() {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          let url = ''
          if (this.searchParams.id) {
            url = '/buz/molCommissionCheckPayment/edit'
          } else {
            url = '/buz/molCommissionCheckPayment/add'
          }
          this.$http({
            url: url,
            type: 'POST',
            data: {
              ...this.searchParams,
              checkId: this.$route.query.id
            },
          }).then(() => {
            this.visible = false
            this.$emit('refresh')
          })
        }
      });
    },
    open(item){
      this.searchParams={}
      if (item) {
        this.getData(item)
      }
      this.visible =true
      this.clearMessage()
    },
    getData(item) {
      this.$http({
        url: '/buz/molCommissionCheckPayment/read/detail',
        type: 'GET',
        data: {
          id: item.id
        },
      }).then((res) => {
        this.searchParams = res.data
      })
    },
    clearMessage(){
      // 基础信息
      this.$refs.formValidate.fields.forEach(item=>{
        item.validateState = '';
        item.validateMessage = '';
      });
    },
  }

}
</script>

<style lang="scss" scoped>
/deep/ .ivu-date-picker{
  width: 100%;
}
/deep/ .ivu-modal-body{
  padding-top: 20px !important;
}
/deep/ .ivu-form{
  display: flex;
  flex: 1;
  flex-wrap: wrap;
}
/deep/ .ivu-form-item{
  width: 50%;
}
</style>